import React from 'react';

import { Checkbox } from '../../../../common/checkbox/Checkbox';

import './ClientAvailability.css';

export const AvailabilityTable = ({ availability, setAvailability, fieldsDisabled }) => {
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Any Day'];

  const handleCheckboxChange = (day, time) => {
    setAvailability((prevAvailability) => {
      const newAvailability = { ...prevAvailability };

      if (day === 'Any Day' && time === 'anyTime') {
        const anyTimeValue = !newAvailability[day][time];

        daysOfWeek.forEach((d) => {
          newAvailability[d] = Object.fromEntries(Object.keys(newAvailability[d]).map((t) => [t, anyTimeValue]));
        });
      } else if ((day === 'Any Day' || daysOfWeek.includes(day)) && time === 'anyTime') {
        const anyTimeValue = !newAvailability[day][time];

        Object.keys(newAvailability[day]).forEach((t) => {
          newAvailability[day] = {
            ...newAvailability[day],
            [t]: anyTimeValue,
          };
        });
      } else if (day === 'Any Day' && time !== 'anyTime') {
        const timeValue = !newAvailability[daysOfWeek[0]][time];

        daysOfWeek.forEach((d) => {
          newAvailability[d] = {
            ...newAvailability[d],
            [time]: timeValue,
          };
        });
      } else {
        newAvailability[day] = {
          ...newAvailability[day],
          [time]: !newAvailability[day][time],
        };

        if (time !== 'anyTime' && newAvailability[day][time] === false) {
          const anyDayNeedsUnchecking = !daysOfWeek
            .filter((d) => d !== 'Any Day')
            .every((d) => newAvailability[d][time]);

          if (anyDayNeedsUnchecking) {
            newAvailability['Any Day'][time] = false;
          }
        }

        if (time !== 'anyTime' && newAvailability[day][time] === false) {
          const anyTimeNeedsUnchecking = !Object.keys(newAvailability[day])
            .filter((t) => t !== 'anyTime')
            .every((t) => newAvailability[day][t]);

          if (anyTimeNeedsUnchecking) {
            newAvailability[day]['anyTime'] = false;
          }
        }
      }

      if (time === 'anyTime' && newAvailability[day][time] === false) {
        const anyTimeNeedsUnchecking = !daysOfWeek
          .filter((d) => d !== 'Any Day')
          .every((d) => newAvailability[d]['anyTime']);

        if (anyTimeNeedsUnchecking) {
          newAvailability['Any Day']['anyTime'] = false;
        }
      }

      return newAvailability;
    });
  };

  return (
    <div className="availability-table-container">
      <div className="availability-header-container">
        <div className="availability-label-day" />
        <div className="availability-header">
          Early Morning<p>(Before 08:00)</p>
        </div>
        <div className="availability-header">
          Morning<p>(08:00 - 12:00)</p>
        </div>
        <div className="availability-header">
          Afternoon<p>(12:00 - 16:00)</p>
        </div>
        <div className="availability-header">
          Late Afternoon<p>(After 16:00)</p>
        </div>
        <div className="availability-header">Any Time</div>
      </div>
      <div className="availability-table-body">
        {daysOfWeek.map((day) => (
          <div key={day} className="availability-row">
            <div className="availability-label-day">
              <label>{day}</label>
            </div>
            {['earlyMorning', 'morning', 'afternoon', 'lateAfternoon', 'anyTime'].map((time) => (
              <div key={time} className="availability-checkbox">
                <Checkbox
                  checked={availability[day] && availability[day][time]}
                  onChange={() => handleCheckboxChange(day, time)}
                  disabled={fieldsDisabled}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
